import { QueryClient, QueryClientProvider } from "@tanstack/react-query";
import { App as Antd, notification } from "antd";
import { BrowserRouter } from "react-router-dom";

import View from "./View";

import { CloseOutlined } from "@ant-design/icons";

notification.config({
  placement: "topRight",
  closeIcon: <CloseOutlined />,
});

const queryClient = new QueryClient({
  defaultOptions: { queries: { retry: false } },
});

export function App() {
  return (
    <Antd>
      <QueryClientProvider client={queryClient}>
        <BrowserRouter>
          <View />
        </BrowserRouter>
      </QueryClientProvider>
    </Antd>
  );
}
